import { MoreVertical } from "lucide-react";
import type { ReactNode } from "react";

import { IconButton, Menu, MenuContent, MenuTrigger } from "@nexus/ui";

/** Secondary page options sit after the scope controls at the edge of the header. */
export function PageMoreMenu({ children }: { children?: ReactNode }) {
  if (!children) return null;

  return (
    <Menu modal={false}>
      <MenuTrigger asChild>
        <IconButton label="More actions" variant="ghost" size="lg" className="text-secondary">
          <MoreVertical className="size-4" aria-hidden />
        </IconButton>
      </MenuTrigger>
      <MenuContent align="end" collisionPadding={8} className="min-w-56">
        {children}
      </MenuContent>
    </Menu>
  );
}
